import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Input,
  Stack,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudBolt, faMessage, faCloud } from "@fortawesome/free-solid-svg-icons";

function SessionStopped({ startSession, sessionError }) {
  const [isActivating, setIsActivating] = useState(false);

  useEffect(() => {
    if (sessionError) {
      setIsActivating(false);
    }
  }, [sessionError]);

  function handleStartSession() {
    if (isActivating) return;

    setIsActivating(true);
    startSession();
  }

  return (
    <Flex width="100%" justifyContent="center">
      <Stack direction="row" spacing={4} align="center">
        <Button
          onClick={handleStartSession}
          className={isActivating ? "bg-gray-600" : "bg-red-600"}
          leftIcon={<FontAwesomeIcon icon={faCloudBolt} />}
          isLoading={isActivating}
          colorScheme="red"
          variant="solid"
          loadingText="Starting session..."
        >
          Start Session
        </Button>
      </Stack>
    </Flex>
  );
}

function SessionActive({ stopSession, sendTextMessage }) {
  const [message, setMessage] = useState("");

  function handleSendClientEvent() {
    sendTextMessage(message);
    setMessage("");
  }

  return (
    <Flex width="100%" alignItems="center" gap={2}>
      <Input
        placeholder="Send a text message..."
        flex={1}
        onKeyDown={(e) => {
          if (e.key === "Enter" && message.trim()) {
            handleSendClientEvent();
          }
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <ButtonGroup>
        <Button
          onClick={() => {
            if (message.trim()) {
              handleSendClientEvent();
            }
          }}
          leftIcon={<FontAwesomeIcon icon={faMessage} />}
        >
          Send Text
        </Button>
        <Button onClick={stopSession} leftIcon={<FontAwesomeIcon icon={faCloud} />}>
          Disconnect
        </Button>
      </ButtonGroup>
    </Flex>
  );
}

export default function SessionControls({
  startSession,
  stopSession,
  sendTextMessage,
  isSessionActive,
  sessionError,
}) {
  return (
    <Box 
      width="100%" 
      bgColor="InfoBackground" 
      p={4} 
      borderTop="1px solid" 
      borderColor="gray.200"
    >
      {isSessionActive ? (
        <SessionActive
          stopSession={stopSession}
          sendTextMessage={sendTextMessage}
        />
      ) : (
        <SessionStopped 
          startSession={startSession} 
          sessionError={sessionError}
        />
      )}
    </Box>
  );
}
